import React from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle2, Settings, Star } from 'lucide-react';
const features = [{
  icon: <Clock className="w-8 h-8 text-accent-cyan" data-id="element-46" />,
  title: 'Recuperá tus domingos',
  description: 'Sin armar nada desde cero. Imprimir y dar clase.'
}, {
  icon: <CheckCircle2 className="w-8 h-8 text-accent-cyan" data-id="element-47" />,
  title: 'Alineado a INET',
  description: 'Material conforme a marcos de referencia nacionales.'
}, {
  icon: <Settings className="w-8 h-8 text-accent-cyan" data-id="element-48" />,
  title: 'Química Situada',
  description: 'Ejemplos reales de procesos industriales y de taller.'
}, {
  icon: <Star className="w-8 h-8 text-accent-cyan" data-id="element-49" />,
  title: 'Garantía 360',
  description: 'Actualizaciones gratuitas de por vida en tu bóveda digital.'
}];
export function Features() {
  return <section className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-50">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-51">
        {features.map((feature, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="flex gap-6 items-start" data-id="element-52">
            <div className="shrink-0 p-3 bg-accent-cyan/10 rounded-xl" data-id="element-53">
              {feature.icon}
            </div>
            <div data-id="element-54">
              <h3 className="text-xl font-bold mb-2" data-id="element-55">{feature.title}</h3>
              <p className="text-text-muted leading-relaxed" data-id="element-56">
                {feature.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}